module.exports = __webpack_public_path__ + "img/img-2.0ee81b18.png";